import { getStickyTopOffset } from "./sticky-top-offset";

const SCROLLABLE_DESKTOP_CONTAINER_ID = "scrollable-desktop-container";

/**
 * Scrolls a card back into view, used when a show-more list collapses. Shared by ShowMore and
 * GridCardWrapper.
 *
 * Measured fresh at call time, not cached in state, so newly-rendered banners are accounted for.
 */
export const scrollCardIntoView = (cardRef: HTMLDivElement | null): void => {
  if (!cardRef) {
    return;
  }

  const scrollableDesktopContainer = document.getElementById(SCROLLABLE_DESKTOP_CONTAINER_ID);
  const offset = getStickyTopOffset(!!scrollableDesktopContainer);
  const cardTop = cardRef.getBoundingClientRect().top - offset;

  if (scrollableDesktopContainer) {
    const containerTop = scrollableDesktopContainer.getBoundingClientRect().top;

    scrollableDesktopContainer.scrollTo({
      top: scrollableDesktopContainer.scrollTop + cardTop - containerTop,
      behavior: "smooth",
    });

    return;
  }

  window.scrollTo({ top: window.scrollY + cardTop, behavior: "smooth" });
};
